export const LOADER_TEST_ID = 'generic-loader';
export const ERROR_TEST_ID = 'generic-error';
